import { Grid, Paper } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ExportFileSearchFilter } from 'src/modules/me/models/exportFilterSearchFilter';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useLocalStorage } from 'src/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'src/shared/models/enums/localStorageKeys.enum';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { FundraiserSearchFilter } from '../../fundraiser/models/fundraiserSearchFilter';
import { WebFormsDataGrid } from '../components/webFormsDataGrid';

export const WebFormsOverviewPage = () => {
  const { t } = useTranslation(['fundraiser']);

  const [webFormsSearchFilter, setWebFormsSearchFilter] = useLocalStorage(LocalStorageKeys.WebFormsSearchFilter, {
    sortCol: 'formName',
    sortDir: 'desc',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  } as FundraiserSearchFilter);

  const searchFilter: FundraiserSearchFilter = useMemo(() => {
    return {
      filter: webFormsSearchFilter?.filter,
      pageSize: webFormsSearchFilter?.pageSize,
      pageIndex: webFormsSearchFilter?.pageIndex,
      sortCol: webFormsSearchFilter?.sortCol,
      sortDir: webFormsSearchFilter?.sortDir,
    } as ExportFileSearchFilter;
  }, [
    webFormsSearchFilter?.filter,
    webFormsSearchFilter?.pageIndex,
    webFormsSearchFilter?.pageSize,
    webFormsSearchFilter?.sortCol,
    webFormsSearchFilter?.sortDir,
  ]);

  return (
    <GridWrapper>
      <Grid item xs={12} md={4}>
        <MainContentHeader title={t('webforms:overviewPage.pageTitle')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <WebFormsDataGrid
            loadingCallback={(x) => ConsoleHelper.log(x)}
            searchFilter={searchFilter}
            searchFilterCallback={(newFilter) =>
              setWebFormsSearchFilter((prev) => ({
                ...prev,
                ...newFilter,
              }))
            }
          />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
